import {
  ATTENDANCE_STATUSES,
  LEAVE_STATUSES,
  REQUEST_STATUSES,
} from '../api/constants';

const BadgeStatus = ({ status, t }) => {
  const statusStr = status ? String(status) : '';
  const statusLower = statusStr.toLowerCase();

  const getBadgeClass = () => {
    // Attendance Statuses
    if (
      statusStr === ATTENDANCE_STATUSES.ASSIGNED ||
      statusStr === LEAVE_STATUSES.APPROVED
    )
      return 'bg-primary';
    if (statusStr === ATTENDANCE_STATUSES.ON_TIME) return 'bg-success';
    if (
      statusStr === ATTENDANCE_STATUSES.LATE ||
      statusStr === ATTENDANCE_STATUSES.LATE_ALLOWED_TO_WORK ||
      statusStr === ATTENDANCE_STATUSES.LATE_SENT_HOME
    )
      return 'bg-danger';
    if (
      statusStr === ATTENDANCE_STATUSES.ABSENT ||
      statusStr === ATTENDANCE_STATUSES.CANCELLED
    )
      return 'bg-secondary';

    // Leave/Claim Statuses
    if (statusLower.includes(REQUEST_STATUSES.PENDING.toLowerCase())) {
      return 'bg-warning';
    }

    if (statusStr === REQUEST_STATUSES.APPROVED) return 'bg-success';
    if (statusStr === REQUEST_STATUSES.REJECTED) return 'bg-danger';
    if (statusStr === REQUEST_STATUSES.CANCELLED) return 'bg-secondary';

    return 'bg-dark';
  };

  return (
    <span
      className={`badge ${getBadgeClass()}`}
      style={{
        fontSize: 12,
        fontWeight: 500,
        padding: '6px 8px',
        color: '#fff',
        borderRadius: '7px',
        textTransform: 'capitalize',
        height: '26px',
      }}
    >
      {statusStr === 'Assigned'
        ? t('Assigned')
        : statusStr === 'On Time'
        ? t('On Time')
        : statusStr === 'Late'
        ? t('Late')
        : statusStr}
    </span>
  );
};

export default BadgeStatus;
